export default { sha: '6983b75e0a9d349ca37729313ee2a5e41b0c52fc', buildNumber: 'undefined' }
